export default __webpack_public_path__ + "static/solar_anim-999d4ddb16f1a64640e54969c699c3d3.mp4";